export const LOADING_AGENCIES = 'agencies/LOAD_AGENCIES'
export const LOADING_AGENCIES_SUCCESS = 'agencies/LOAD_AGENCIES_SUCCESS'
export const LOADING_AGENCIES_FAILURE = 'agencies/LOAD_AGENCIES_FAILURE'
